<template>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: "index",
    computed: {
      ...mapGetters([ 'isLogin', 'getUserId' ]),

    },
    methods: {
      setUserId(userId) {
        this.$store.commit('setUserId', userId);
      }
    },
    mounted() {
      let userId = this.$route.query.uid;
      if (userId) {
        sessionStorage.setItem("_uid", userId + "");
        this.$router.push({ path: '/CurrentClass' });
        // location.href = process.env.SERVER_ADDRESS + '#/CurrentClass';
      } else {
        alert('请关闭当前页面后，重新操作');
        //   location.href = 'https://xiandaoxueyuan.com/?m=user2&a=login';
      }
      // }

      // sessionStorage.setItem("_uid", "25");
      // location.href = 'http://127.0.0.1:8080#/CurrentClass';
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Index/index.vue